// ENTITY fr.gestionpial.pial.dto.EmploiDuTempsAeshDTO generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { Aesh } from './Aesh';
import { CreneauAffectation } from './CreneauAffectation';
import { EmploiDuTempsLookupsDTO } from './EmploiDuTempsLookupsDTO';

export class EmploiDuTempsAeshDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.EmploiDuTempsAeshDTO';

  aesh: Aesh | null = null;
  volumeHoraireContrat: number | null = 0;
  creneaux: CreneauAffectation[] | null = [];
  creneauxAutres: CreneauAffectation[] | null = [];
  lookups: EmploiDuTempsLookupsDTO | null = null;

  constructor(init?:Partial<EmploiDuTempsAeshDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.EmploiDuTempsAeshDTO'] = EmploiDuTempsAeshDTO;

fields['fr.gestionpial.pial.dto.EmploiDuTempsAeshDTO']  = {
    aesh: 'fr.gestionpial.pial.entities.Aesh',
    volumeHoraireContrat: 'java.lang.Integer',
    creneaux: 'java.util.List<fr.gestionpial.pial.entities.CreneauAffectation>',
    creneauxAutres: 'java.util.List<fr.gestionpial.pial.entities.CreneauAffectation>',
    lookups: 'fr.gestionpial.pial.dto.EmploiDuTempsLookupsDTO'
};
